<template>
    <div class="app-wrapper" :class="{ noscroll: showMessage && token }">
        <div class="mcontent">
            <NavBar />
            <section class="m_container">
                <Banner />
                <div v-loading="loading" class="whtie_wrap_tougao">
                    <div v-if="showMember" class="form_wrap member_wrap">
                        <p class="form_tilte">{{ $t('tougao.basic_info') }}</p>
                        <form-create ref="memberSetting" v-model="fApi" :rule="memberRule" :option="option" @change="formcreateChange" />
                    </div>
                    <div class="form_wrap zuopin_wrap">
                        <p class="form_tilte">{{ $t('tougao.zuopin_info') }}</p>
                        <form-create ref="zuopinSetting" v-model="fApi1" :rule="zuopinRule" :option="option" @category-id-change="onChangeCategory" />
                        <form-create v-if="zuopinCRule.length" v-model="fApi2" :rule="zuopinCRule" :option="option" />
                    </div>
                    <ElButton v-loading="saveLoading" type="primary" class="submitbtn" @click="submitForm">
                        {{ $t('tougao.submit') }}
                    </ElButton>
                </div>
            </section>
            <Footer />
        </div>
        <!-- 协议 弹窗 -->
        <Agreement v-if="showMessage && token" :visible="showMessage" :agreement="agreement" :status="agree" @clickAgree="handleAgree" />
    </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import Footer from '@/components/Footer'
import Banner from '../home/component/banner'
import Agreement from './component/agreement.vue'
import mixin_formCreate from '@/utils/project/formCreate_mixin'
import { getTreeChildren } from '@/utils/project/common'
import { getToken, getTid, setTid, getAgreement, setAgreement } from '@/utils/cookies'
import { memberInfo, saveMember, editMember, zuopinInfo, addZuopin, editZuopin } from '@/api/Tougaos'
import { mapGetters } from 'vuex'

export default {
    name: 'Tougao',
    components: { NavBar, Footer, Banner, Agreement },
    mixins: [mixin_formCreate],
    data() {
        return {
            froms: '',
            language: this.$store.getters.language,
            tid: this.$route.query.tid ? this.$route.query.tid : getTid(),
            zuopin_id: this.$route.query.zuopin_id,
            loading: true,
            saveLoading: false,
            showMember: false,
            agree: false,
            memberRule: [],
            zuopinRule: [],
            zuopinCRule: [],
            fApi: {},
            fApi1: {},
            fApi2: {},
            option: {
                form: {
                    inline: true,
                    labelPosition: 'right',
                    labelWidth: '100'
                },
                submitBtn: {
                    icon: 'none',
                    show: false
                }
            },
            ajaxData: {
                id: undefined,
                tid: this.tid,
                info: ''
            },
            zpAjaxData: {
                id: undefined,
                tid: this.tid,
                member_id: '',
                info: {}
            },
            isconfirm: false,
            showMessage: false // 协议 弹窗 需知
        }
    },

    computed: {
        ...mapGetters([
            'tougaoInfo',
            'tougaoSetting',
            'categoryList',
            'categoryListEn',
            'memberSetting',
            'memberSettingEn',
            'zuopinSetting',
            'zuopinSettingEn'
        ]),
        categoryList_() {
            return this.language === 'en' ? this.categoryListEn : this.categoryList
        },
        agreement() {
            const { language, tougaoSetting } = this
            return language === 'en' ? tougaoSetting.agreement_en : tougaoSetting.agreement
        }
    },

    beforeRouteEnter: (to, from, next) => {
        console.log('from', from.path)
        next((vm) => {
            if (!getToken()) {
                vm.toLogin()
            }
            vm.isconfirm = to.query.isconfirm ? Boolean(to.query.isconfirm) : false
            vm.froms = Number(to.query.isEdit) ? from.path : ''
        })
    },

    mounted() {
        // #region 协议处理
        const isAgree = getAgreement()
        if (!isAgree) {
            this.agreement && this.agreement.length > 0 ? (this.showMessage = true) : (this.showMessage = false)
        }
        // #endregion
    },

    created() {
        if (!getToken()) {
            return
        }
        this.tid ? setTid(this.tid) : ''
        this.getMemberInfo()
    },

    methods: {
        handleAgree() {
            // 协议
            this.agree = !this.agree
            if (this.agree) {
                this.showMessage = false
                setAgreement(1)
            }
        },

        toLogin() {
            this.$alert(this.$t('Notification.login_tip'), this.$t('Notification.tip'), {
                confirmButtonText: this.$t('Notification.sure'),
                callback: (action) => {
                    this.$router.push({
                        path: '/login',
                        query: { tid: this.tid }
                    })
                }
            })
        },

        // radio、select change事件
        formcreateChange(e) {
            if (e !== 'card_type') return
            let cFormName = ''
            Object.keys(this.$refs.memberSetting.$refs).forEach((item) => {
                if (item.includes('cForm')) {
                    cFormName = item
                }
            })
            if (cFormName) {
                this.$refs.memberSetting.$refs[cFormName].clearValidate()
            }

            // cForm2.clearValidate()
            // 获取当前radio、select的下标【身份证类型 e=card_type】
            const index = this.memberRule.findIndex((item) => item.field === e)
            if (index === -1) return

            // 规则校验
            if (this.memberRule[index].props.effectRequiredField) {
                // 获取被radio、select影响的字段和下标【身份证号 id_card】
                const effect_field = this.memberRule[index].props.effectRequiredField
                const effect_field_idx = this.memberRule.findIndex((item) => item.field === effect_field)
                // 被影响字段不存在
                if (effect_field_idx === -1) return

                // 根据被影响的字段 校验规则【身份证号 id_card 校验规则】
                const validate = this.getValidatorCallBackNew(e, this.fApi)
                // 新增、删除 被影响的字段 校验规则 【新增、删除 身份证号 id_card 校验规则】
                let additional_validate_idx = -1
                if (this.memberRule[effect_field_idx].validate.length) {
                    additional_validate_idx = this.memberRule[effect_field_idx].validate.findIndex((item) => item.additional)
                }
                additional_validate_idx === -1
                    ? this.memberRule[effect_field_idx].validate.push(...validate)
                    : this.memberRule[effect_field_idx].validate.splice(additional_validate_idx, 1)
            }
            // 显示逻辑
            if (this.memberRule[index].props.effectShowField) {
                // 获取被radio、select影响的字段和下标【身份证号 id_card】
                const effect_field = this.memberRule[index].props.effectShowField
                const effect_field_idx = this.memberRule.findIndex((item) => item.field === effect_field)
                // 被影响字段不存在
                if (effect_field_idx === -1) return
                // 根据被影响的字段 显示隐藏【身份证号 id_card 显示隐藏】
                const isHidden = this.memberRule[effect_field_idx].hidden
                const effectShowVal = this.memberRule[index].props.effectShowVal
                if (this.fApi.form[e] === effectShowVal) {
                    if (isHidden) return
                    this.$set(this.memberRule[effect_field_idx], 'hidden', {
                        type: 'hidden',
                        field: this.memberRule[effect_field_idx].field
                    })
                } else {
                    isHidden ? this.$delete(this.memberRule[effect_field_idx], 'hidden') : ''
                }
            }
        },

        getMemberInfo() {
            // 基本信息
            memberInfo({ tid: this.tid }).then(async (res) => {
                if (res.code === 200) {
                    const { status, data } = res.data
                    if (status === 0) {
                        // 0 第一次进来
                        this.memberRule = this.resetFormRules(this.language === 'en' ? this.memberSettingEn : this.memberSetting, {})
                        this.zuopinRule = this.resetFormRules(
                            this.language === 'en' ? this.zuopinSettingEn : this.zuopinSetting,
                            {},
                            this.categoryList_
                        )
                        this.showMember = true
                        this.loading = false
                    } else {
                        //  非第一次进来 显示基本信息  获取基本信息
                        this.ajaxData = data
                        this.memberRule = this.resetFormRules(this.language === 'en' ? this.memberSettingEn : this.memberSetting, data.info)
                        if (this.froms === '/my') {
                            // 来自作品列表 获取作品详情
                            await this.getZuopinInfo(this.zuopin_id)
                            this.showMember = true
                            this.loading = false
                        } else {
                            // 不来自作品列表 不显示基本信息
                            this.zpAjaxData.member_id = data.id

                            const rule = this.language === 'en' ? this.zuopinSettingEn : this.zuopinSetting
                            const category_id_index = rule.findIndex((item) => item.field === 'category_id')
                            if (category_id_index !== -1) {
                                const category_id = rule[category_id_index].value
                                if (!category_id) return
                                this.onChangeCategory(category_id)
                            }
                            this.zuopinRule = this.resetFormRules(rule, {}, this.categoryList_)
                            this.showMember = false
                            this.loading = false
                        }
                    }
                }
            })
        },
        // 选择分类
        onChangeCategory(val) {
            const nodes = getTreeChildren(this.categoryList_, val[val.length - 1])
            if (!nodes) {
                this.zuopinCRule = []
                return
            }
            this.zuopinCRule = this.resetFormRules(nodes.setting, this.zpAjaxData.info, this.categoryList_)
        },
        // 获取作品信息
        getZuopinInfo(id) {
            this.loading = true
            zuopinInfo({ id }).then((res) => {
                this.loading = false
                if (res.code === 200) {
                    const { data } = res.data
                    this.zpAjaxData = data
                    this.zuopinRule = this.resetFormRules(
                        this.language === 'en' ? this.zuopinSettingEn : this.zuopinSetting,
                        data.info,
                        this.categoryList_
                    )
                    if (data.info.category_id) this.onChangeCategory(data.info.category_id)
                }
            })
        },
        // 保存基本信息
        saveMemberFun() {
            return new Promise((resolve, reject) => {
                const API = this.ajaxData.id ? editMember : saveMember
                this.ajaxData.tid = this.tid
                API(this.ajaxData)
                    .then((res) => {
                        if (res.code === 200) {
                            this.zpAjaxData.member_id = res.data.id
                            resolve()
                        }
                    })
                    .catch((error) => {
                        this.saveLoading = false
                        reject(error)
                    })
            })
        },
        // 保存作品信息
        saveZuopinFun() {
            return new Promise((resolve, reject) => {
                const API = this.zpAjaxData.id ? editZuopin : addZuopin
                this.zpAjaxData.tid = this.tid
                API(this.zpAjaxData)
                    .then((res) => {
                        if (res.code === 200) {
                            resolve()
                        }
                    })
                    .catch((error) => {
                        this.saveLoading = false
                        reject(error)
                    })
            })
        },
        // 保存-基本信息-接口
        async submitForm() {
            // #region 基本信息校验
            let bool = true

            if (this.showMember) {
                if (!Object.keys(this.fApi).length) return false
                this.fApi.validate((v) => {
                    if (!v) {
                        bool = v
                        this.$message({
                            message: this.$t('Notification.requiredFields'),
                            type: 'warning',
                            showClose: true,
                            duration: 2000
                        })
                        this.saveLoading = false
                        return
                    }
                    this.fApi.submit((formData, $f) => {
                        this.ajaxData.info = formData
                    })
                    console.log('member---ajaxData', this.ajaxData)
                })
            }
            if (!bool) return false
            // #endregion

            // #region 作品信息校验
            if (!Object.keys(this.fApi1).length) return false
            if (Object.keys(this.fApi1).length > 0) {
                this.fApi1.validate((res) => {
                    bool = res
                    if (!res) {
                        this.$message({
                            message: this.$t('Notification.requiredFields'),
                            type: 'warning',
                            showClose: true,
                            duration: 2000
                        })
                        this.saveLoading = false
                        return false
                    }
                    this.fApi1.submit((formData) => {
                        // form-create 提交回调
                        Object.assign(this.zpAjaxData.info, formData)
                    })
                })
            }
            if (!bool) return false
            if (Object.keys(this.fApi2).length > 0) {
                this.fApi2.validate((res) => {
                    bool = res
                    if (!res) {
                        this.$message({
                            message: this.$t('Notification.requiredFields'),
                            type: 'warning',
                            showClose: true,
                            duration: 2000
                        })
                        this.saveLoading = false
                        return false
                    }
                    this.fApi2.submit((formData) => {
                        // form-create 提交回调
                        Object.assign(this.zpAjaxData.info, formData)
                    })
                })
            }
            const { info } = this.zpAjaxData
            Object.keys(info).some((key) => {
                if ((key === 'thumb_ids' || key.includes('CustomUpload')) && info[key][0]) {
                    if (Array.isArray(info[key]) && info[key].length < info[key][0].limitMin) {
                        // const customUploadIndex = key.split('_')[1]
                        // const message = key === 'thumb_ids' ? this.$t('Notification.profile_photo') : `第${customUploadIndex}个上传文件`
                        // const mes = this.$t('Notification.min_file')
                        let idx = -1
                        idx = this.zuopinRule.findIndex((item) => item.field === key)
                        let title = ''
                        if (idx !== -1) {
                            title = this.zuopinRule[idx].title
                        } else {
                            idx = this.zuopinCRule.findIndex((item) => item.field === key)
                            title = this.zuopinCRule[idx].title
                        }
                        const message = key === 'thumb_ids' ? this.$t('Notification.profile_photo') : `【${title}】上传文件`
                        const mes = this.$t('Notification.min_file')

                        this.$message({
                            message: `${message}${mes}${info[key][0].limitMin}`,
                            type: 'warning',
                            showClose: true,
                            duration: 3000
                        })
                        bool = false
                        return true
                    }
                }
            })

            if (!bool) return false

            console.log('zuopin---zpAjaxData', this.zpAjaxData)
            // #endregion

            // #region 提交保存
            this.saveLoading = true
            if (this.showMember) {
                await this.saveMemberFun()
            }
            this.saveZuopinFun()
                .then((res) => {
                    this.$notify({
                        title: this.$t('Notification.suc_title'),
                        message: this.$t('Notification.suc_submit'),
                        type: 'success',
                        duration: 2000
                    })
                    this.saveLoading = false
                    this.$router.push({
                        path: '/my',
                        query: {
                            tid: this.tid,
                            isShow: 1
                        }
                    })
                })
                .catch(() => {
                    this.saveLoading = false
                })
            // #endregion
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: ' ';
}
.app-wrapper {
    position: relative;
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;

    .whtie_wrap_tougao {
        max-width: 1200px;
        min-height: 800px;
        margin: -80px auto 0;
        background: #fff;
        box-sizing: border-box;
        padding: 30px 200px;
        z-index: 100;
        .form_tilte {
            padding-bottom: 40px;
            margin-bottom: 38px;
            border-bottom: 1px solid #eeeeee;
            line-height: 48px;
            font-size: 24px;
            font-weight: bold;
            color: #000;
            position: relative;
            &::before {
                content: '';
                position: absolute;
                top: 8px;
                left: -14px;
                width: 6px;
                height: 30px;
                background: $theme_color;
                border-radius: 3px;
            }
        }
        .zuopin_wrap {
            margin-top: 0 !important;
        }
        .form_wrap {
            margin: 0 auto 100px;
            min-width: 800px;

            .el-form-item--mini.el-form-item,
            .el-form--inline .el-form-item {
                display: flex;
                justify-content: center;
            }

            .form-create {
                .el-form-item__label {
                    flex: 0 0 130px;
                }
            }

            .star_img {
                position: absolute;
                top: 18px;
                left: -160px;
                width: 10px;
                height: 10px;
            }

            .el-form-item__label {
                line-height: 48px;
                font-size: 16px;
                color: #000;
                flex: 0 0 120px;
                margin-right: 20px;
                display: inline-block;
                text-align: justify;
                text-align-last: justify;
            }

            .el-form-item__content {
                width: 450px;
                line-height: 48px;

                .el-input__inner {
                    height: 48px;
                    background: #f2f2f2;
                    border-color: #f2f2f2;
                    border-radius: 24px;
                    padding: 0 30px;
                    font-size: 16px;
                }

                .el-input--mini {
                    font-size: 16px;
                }

                .el-cascader--mini,
                .el-select,
                .el-date-editor.el-input {
                    width: 100%;
                }

                .el-textarea__inner {
                    background-color: #f2f2f2;
                    border: 1px solid #f2f2f2;
                }

                .fc-upload-btn,
                .fc-files {
                    width: 120px;
                    height: 120px;
                    line-height: 120px;
                }
            }
        }
        .submitbtn {
            margin-left: 236px;
            width: 220px;
            height: 48px;
            line-height: 48px;
            padding: 0 20px;
            border-radius: 24px;
        }
    }
}
.category_wrap /deep/.el-radio__input {
    display: none;
}
.category_wrap /deep/.el-radio__label {
    padding-left: 0;
}
.category_wrap /deep/.el-radio {
    margin-right: 10px;
    margin-bottom: 10px;
}
.category_wrap /deep/.el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0;
}
@media screen and (max-width: 1260px) {
    .app-wrapper {
        .banner_wrap {
            .title {
                font-size: 30px;
            }
        }
    }
}
</style>
